<template>
  <div id="roleEdit">

    <PageTitle v-if="ready" :title="id ? role.name : $t('pos_roles.new_single')" />

    <PageContainer v-if="ready">
      <PosRole v-model="role" :permission-data="permissions" :functions="functions"></PosRole>
    </PageContainer>

    <PageFooter :backAction="{action: back, text: $t('back')}" :mainAction="{action: save, text: $t('save')}" />

  </div>
</template>

<script>
  import PageTitle from "@/components/PageTitle";
  import PageContainer from "@/components/PageContainer";
  import PageFooter from "@/components/PageFooter";
  import PosRole from "@/components/qsr/PosRole";
  import {mapActions} from "vuex";

  export default {
    name: "roleEdit",

    components: { PageTitle, PageContainer, PageFooter, PosRole },

    data() {
      return {
        role: null,
        permissions: null,
        functions: []
      }
    },

    computed: {
      id() {
        return this.$route.query.id;
      },
      companyId() {
        return this.$route.query.company;
      },
      ready() {
        return !!this.role
            && !!this.permissions
            && !!this.functions
      }
    },

    async mounted() {
      showSpinner();
      await this.getPermissions();
      await this.loadRole();
      hideSpinner();
    },

    methods: {
      ...mapActions(["getPosPermissions", "getPosRole", "savePosRole", "createPosRole"]),

      async getPermissions() {
        let response = await this.getPosPermissions();
        if (response) {
          this.permissions = response;
        } else {
          toast(this.$t('error.no_server'), 'error');
          this.back();
        }
      },

      async loadRole() {
        if (!this.id) {
          this.role = {
            id: null,
            company: this.companyId
          };
          return;
        }
        let response = await this.getPosRole(this.id);
        if (response) {
          this.role = response;
        } else {
          toast(this.$t('error.no_server'), 'error');
          this.back();
        }
      },

      async save() {
        let data = JSON.parse(JSON.stringify(this.role));

        showSpinner();
        let response = this.id
            ? await this.savePosRole(data)
            : await this.createPosRole(data);
        hideSpinner();
        if (response) {
          this.role = response;
          toast(this.$t("pos_roles.save_success"), "success", this.$t("success"));
          let editPath = "/role/edit";
          if (this.role.id && this.$route.path !== editPath) {
            await this.$router.replace(this.$router.buildContext(editPath, {id: this.role.id}));
          }
        } else {
          toast(this.$t("pos_roles.save_error"), "error", this.$t("error.title"));
        }
      },

      back() {
        this.$router.push(this.$router.buildContext("/roles"));
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>